var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "custom-conditions" } },
    [
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.resource(
                    "JourneyComposer_BrickSettingsTouchpoint_Custom_Conditions_Header"
                  )
                ) +
                "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary",
              attrs: { disabled: _vm.parentType === "" },
              on: { click: _vm.addCondition }
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(
                " " + _vm._s(_vm.resource("Button_Add")) + "\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.newValue, function(condition) {
        return _c("custom-condition", {
          key: condition.id,
          attrs: {
            canWrite: _vm.canWrite,
            parentType: _vm.parentType,
            value: condition
          },
          on: {
            delete: function($event) {
              return _vm.removeCondition($event)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }